var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VB_Brochure_Contact",class:{ VB_Brochure_Contact__qr: _vm.qr }},[_c('pre',{staticClass:"VB_Brochure_Contact_Info",domProps:{"innerHTML":_vm._s(_vm.contact)}})])}
var staticRenderFns = []

export { render, staticRenderFns }